<ngx-spinner template="<img src='assets/images/giphy.gif'/>" size="large"></ngx-spinner>
<app-toast-container></app-toast-container>
<router-outlet></router-outlet>
<app-crash-modal></app-crash-modal>
